import { useEffect, useRef, useState } from 'react'
import {
  StyledModal,
  IframePlace,
  StyledIframe,
  LoaderPlace,
  ModalHeader,
  CloseButton,
} from './styles'
import Loader from '../Loader'
import { Icon } from 'bd-web-components'
import { PRIMARY_BLUE_03 } from 'bd-web-components/src/utils/dash-colors'
import { customEncodeUrlParam } from '../../utils/custom-encode'

interface ConfirmationModalProps {
  user: {
    id: number
    usuario: string
  }
  event: EventDataNPS
  service: string
  isOpen: boolean
  onRequestClose: () => void
}
export interface EventDataNPS {
  id?: string
  event_name: string
  pracaId: string
  praca: string
}

export const NPSModal = ({
  user,
  event,
  service,
  isOpen,
  onRequestClose,
}: ConfirmationModalProps) => {
  const [loading, setLoading] = useState<boolean>(true)
  const formUrl = process.env.REACT_APP_NPS_FORM_URL
  const prePopulatedUrl = `?eid=${event.id}&enome=${customEncodeUrlParam(
    event.event_name
  )}&pnome=${customEncodeUrlParam(event.praca)}&pid=${event.pracaId}&uid=${
    user.id
  }&unome=${user.usuario}&servico=${service}&chave=${
    event.id + service + user.id
  }&postMessage=true`

  const fullUrl = formUrl + prePopulatedUrl
  const iframeRef = useRef<HTMLIFrameElement>(null)

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (!event.origin.includes('jotform.com')) {
        return
      }
      if (event.data) {
        if (event.data.action === 'submission-completed') {
          setTimeout(() => {
            onRequestClose()
          }, 1500)
        }
      }
    }
    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [onRequestClose])

  return (
    <StyledModal
      isOpen={isOpen}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
      }}
    >
      <ModalHeader>
        <div>
          <CloseButton
            // @ts-ignore
            onClick={onRequestClose}
            type="button"
          >
            <Icon
              width={18}
              height={18}
              iconName={'x'}
              fill={PRIMARY_BLUE_03}
              classes="add-account-chevron"
            />
          </CloseButton>
        </div>
      </ModalHeader>
      <LoaderPlace className={loading ? 'visible' : 'hidden'}>
        <Loader />
      </LoaderPlace>
      <IframePlace className={!loading ? 'visible' : 'hidden'}>
        <StyledIframe
          onLoad={() => setLoading(false)}
          ref={iframeRef}
          src={fullUrl}
          title="Dashboard NPS"
        />
      </IframePlace>
    </StyledModal>
  )
}
